import { ReactSDKClient } from '@sbt-web/houston-wrapper';
import { getDetailSearchId } from '@/client/bridges/navigation-data';
import { SearchData } from './types';

export const getSearchValue = (): SearchData | undefined => {
  const searchId = getDetailSearchId();

  if (!searchId) {
    return undefined;
  }

  return {
    id: searchId,
    rank: window.subito?.dataLayer?.ads?.[0]?.rank,
  };
};

export const MESSAGING_DEMERGE_GET_ROLLOUT_TOGGLE =
  'it.subito.web.demerge.messaging.get.rollout';
export const MESSAGING_DEMERGE_AD_REPLY_ROLLOUT_TOGGLE =
  'it.subito.web.demerge.messaging.adreply.rollout';

export const isUserEligibleForStream = async (
  userId: string,
  optimizely: ReactSDKClient | null
): Promise<boolean> => {
  try {
    await optimizely?.onReady();

    return (
      optimizely?.isFeatureEnabled(
        MESSAGING_DEMERGE_GET_ROLLOUT_TOGGLE,
        userId,
        {
          userID: userId,
        }
      ) ?? false
    );
  } catch {
    return false;
  }
};

export const isUserEligibleForStreamAdReplyRollout = async (
  userId: string,
  optimizely: ReactSDKClient | null
): Promise<boolean> => {
  try {
    await optimizely?.onReady();

    return (
      optimizely?.isFeatureEnabled(
        MESSAGING_DEMERGE_AD_REPLY_ROLLOUT_TOGGLE,
        userId,
        {
          userID: userId,
        }
      ) ?? false
    );
  } catch {
    return false;
  }
};
